import React from "react";
import { BatteryLow, Activity, Users } from "lucide-react";

const BLOCKS = [
  {
    icon: BatteryLow,
    title: "Erschöpfung trotz Einsatz",
    text: "Du trainierst regelmäßig, isst bewusst – und bist trotzdem ständig müde. Niemand konnte dir bisher erklären, warum.",
  },
  {
    icon: Activity,
    title: "Beschwerden, die bleiben",
    text: "Rückenschmerzen, Verspannungen oder andere Beschwerden, die weder ein Arzt noch dein letztes Fitnessstudio in den Griff bekommen haben.",
  },
  {
    icon: Users,
    title: "Zu viele Experten, kein Gesamtbild",
    text: "Ein Trainer hier, ein Ernährungsberater dort – aber niemand, der dein Training und deine Nährstoffversorgung gemeinsam betrachtet.",
  },
];

export default function PainSection() {
  return (
    <section
      id="pain-section"
      data-testid="pain-section"
      className="bg-[#F7F9FB] text-[#1F2937] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <p className="text-xs sm:text-sm font-semibold tracking-[0.18em] uppercase text-[#2E89C4] mb-5">
            Kennst du das?
          </p>
          <h2
            data-testid="pain-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight"
          >
            Kommt dir das bekannt vor?
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
          {BLOCKS.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={i}
                data-testid={`pain-card-${i}`}
                className="relative rounded-2xl border border-[#1F2937]/10 bg-white/60 backdrop-blur-sm p-7 lg:p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_-25px_rgba(43,43,43,0.35)] hover:border-[#2E89C4]/30"
              >
                <div className="h-12 w-12 rounded-xl bg-[#2E89C4]/10 flex items-center justify-center mb-6">
                  <Icon size={22} className="text-[#2E89C4]" strokeWidth={1.8} />
                </div>
                <h3 className="font-display text-xl font-bold mb-3">
                  {b.title}
                </h3>
                <p className="text-[15px] leading-relaxed text-[#1F2937]/75">
                  {b.text}
                </p>
                <span className="absolute top-6 right-6 font-display text-sm font-bold text-[#1F2937]/15">
                  0{i + 1}
                </span>
              </div>
            );
          })}
        </div>

        {/* Belief Deconstruction */}
        <div
          data-testid="belief-deconstruction"
          className="mt-20 lg:mt-24 grid lg:grid-cols-12 gap-8 items-start"
        >
          <div className="lg:col-span-4">
            <div className="inline-flex items-center gap-3 text-xs font-semibold tracking-[0.2em] uppercase text-[#6FB04F]">
              <span className="h-px w-8 bg-[#6FB04F]" />
              Die halbe Wahrheit
            </div>
          </div>
          <div className="lg:col-span-8">
            <p className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold leading-[1.2] tracking-tight">
              Die meisten glauben, mehr Disziplin oder ein härteres Programm sei
              die Lösung.{" "}
              <span className="text-[#2E89C4]">Tatsächlich liegt</span> die
              Ursache oft tiefer – in{" "}
              <span className="underline decoration-[#6FB04F] decoration-4 underline-offset-4">
                Nährstoffmängeln
              </span>
              , die durch reines Training nie sichtbar werden.
            </p>
            <p className="mt-6 text-base lg:text-lg text-[#1F2937]/70 leading-relaxed max-w-2xl">
              Ein Trainer ohne Blick auf deine Nährstoffversorgung sieht immer
              nur die halbe Wahrheit.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
